
import { Component, Vue,Prop } from 'vue-property-decorator';
import ObjectTableVue from './ObjectTable.vue';
import { IBot, botType } from "../../../server/src/ai/interface/IBot"
import { BotStore } from './interface/BotStore';
import { IParam } from 'server/src/ai/interface/IParam';
import { DragManager, typeMoveBot, typeSelectBot, typeMoveParam, typeMoveObj } from "./DragManager";


@Component({components: {  ObjectTableVue} })
export default class BotParamsVue extends Vue {
  @Prop(String)   params_key:string|undefined
  @Prop(String)   title:string | undefined
  @Prop(Boolean)  can_see_code:boolean | undefined
  @Prop(Object)   store: BotStore | undefined
  @Prop(Object)   bot: IBot | undefined

  @Prop(Function) go:any
  @Prop(Function) run:any
  dm=DragManager.getInstance()

  params:  { [key: string]: IParam} = {}

  key=0;
  get _params_key() { return this.params_key?this.params_key:"";}
  get _params() { 
     if (this.bot && this._params_key) return (<any>this.bot)[this._params_key]
     return {}; 
  }
  get _can_see_code() { return this.can_see_code;}
  get _bot_id() { return this.bot?.id?this.bot.id:''}
  get _store() { return this.store;}

  async mounted() {
    this.refresh()
  }

  async refresh() {
    //this.adjustAllTextareaHeights();
    this.key++
  }

  isString(variable: any): boolean {
    return typeof variable === 'string';
  }


  async listRowSelected(obj:any) {
    if (!this.bot) return;
    for (const k of Object.keys(obj)) {
      //const set:IParamSet = { param: {key: k, value:obj[k], id:this._bot_id} }
      
      //await this.store?.set_result(this.bot,set)
    }
  }


 

  extractParams(sql: string): string[] {
    const regex = /\{(\w+)\}/g; // Regular expression to match parameters inside {}
    const params: string[] = [];
    let match;
    while ((match = regex.exec(sql)) !== null) {
        params.push(match[1]); // Group 1 contains the parameter name
    }
    return params;
}

async podmień_parametry(prompt:string, parametry:any)
 {  
  let wynik = prompt;  
  for (let parametr in parametry) {
        const nazwa_parametru = `{${parametr}}`;
        const wartość_parametru = parametry[parametr].value;
        wynik = wynik.split(nazwa_parametru).join(wartość_parametru);
   }  
   return wynik;
}


 async handleDragStart(key:string, set: IParam, event:MouseEvent) {

    event.stopPropagation();
    event.preventDefault();

    this.dm.reset(typeMoveBot)
    this.dm.reset(typeMoveParam)
    this.dm.reset(typeMoveObj)
    this._params[key].src_id = this.bot?.id

    console.log("handleDragStart BotParamsVue", key, this._params[key])
    this.dm.set(this._params[key], typeMoveParam)
    this.dm.show_tooltip(key+':'+this._params[key].value, event.clientX-10, event.clientY+10 )

  }

  async handleDrop(key:string,  event: any) {

    if (!this.store) return;
    if (!this._bot_id) return;
    if (!this.bot) return;


/*
    if (key=='instrukcja') {
        // drag and drop text
        event.preventDefault();  
        let text = event.dataTransfer.getData('text');  
        console.log(text); 
        const d:IParam = this._params[key]
        d.value = text
        await this.store.saveBot(this.bot)
        await this.refresh()
        if (text) return
    }
*/
    console.log("BotParamsVue handleDrop", event)
   

    let  nest=false
    if (event.ctrlKey) nest=true;
    
    if (this.dm.get(typeMoveParam)) {
      console.log("BotParamsVue handleDrop move param")

      const s = this.dm.get(typeMoveParam)
      const d:IParam = this._params[key]
      
      d.value = s?.value
      d.src_id = s?.id
      d.src_key = s?.key

      event.preventDefault();
      event.stopPropagation();
      const param_names = this.extractParams(d.value)
      for (let name of param_names) {
          if (!nest) {
            if (!this.params[name]) {
              this._params[name]={ id: this._bot_id, key:name, value:""}
            } 
          }
          else {
              this._params[name]={ id: this._bot_id, key:name, value:""}
          }
          
      }
      this.dm.reset(typeMoveParam)
      this.dm.hide_tooltip()
    } 

    if (this.dm.get(typeMoveObj)) {
      
      const s = this.dm.get(typeMoveObj)
      console.log("BotParamsVue handleDrop move obj", s)
      const d:IParam = this._params[key]
      d.value = s?.value

      event.preventDefault();
      event.stopPropagation();

      const param_names = this.extractParams(d.value)
      nest=false
      if (!nest) {
        for (let name of param_names) {
              if (!this.params[name]) {
                this._params[name]={ id: this._bot_id, key:name, value:""}
              }
        }
      } else {
            if (!d.value) d.value={}
            if (!(d.value instanceof Object)) d.value={}
            d.value[s.key] = {value:s?.value}
      }
      
      this.dm.reset(typeMoveObj)
      this.dm.hide_tooltip()
    }

    await this.store.saveBot(this.bot)
    await this.refresh()

   }


  async bot_go() {
    if (!this.go) return;
    await this.go()
  }

  async bot_run() {
    if (!this.run) return;

    await this.run()
  }

  copyToNotepad(value:string) {
    if (!this.bot) return;
    const valueToCopy = JSON.stringify(value);

    // Create a temporary textarea element to facilitate copying to clipboard
    const textarea = document.createElement('textarea');
    textarea.value = valueToCopy;
    document.body.appendChild(textarea);

    // Select the value within the textarea
    textarea.select();
    textarea.setSelectionRange(0, 99999); // For mobile devices

    // Copy the selected text to clipboard
    document.execCommand('copy');

    // Remove the temporary textarea
    document.body.removeChild(textarea);

    alert('Skopiowano do notatnika.');
  }

   get_source_name(p:any) {
    //if (!p.src_id) return ""
    return ''
    /*
    if (!this.store?.botsMap[p.src.id]) return ''
    if (!this.store?.botsMap[p.src.id].results) return ''
    if (!this.store?.botsMap[p.src.id].results.nazwa) return ''
    if (!this.store?.botsMap[p.src.id].results.nazwa.param.value) return ''
    const name =  (this.store?.botsMap[p.src.id].results.nazwa.param.value)
    if (!name) return ''
    return name+"."+p.src.key
    */
  }

  ignore_mouse(event:MouseEvent) {
    console.log("this.ignore_mousedown")
    event.stopPropagation()
    //event.preventDefault()
  }


adjustAllTextareaHeights() {
      this.$nextTick(() => {
        const textareas = this.$el.querySelectorAll('textarea');

        textareas.forEach(textarea => {
          textarea.style.height = 'auto';
          textarea.style.height = textarea.scrollHeight + 'px';
        });
      });
  }
}
